module.exports = __webpack_public_path__ + "MapPin_Navy___3lo9u.svg";